export const ASSIGNMENT_TYPE = 'assignmentType'
export const STATUS = 'status'
export const DISTRIBUTION_CHANNEL = 'distributionChannel'
export const DATE_FROM = 'dateFrom'
export const DATE_TO = 'dateTo'
export const SEARCH = 'search'
export const ARCHIVE_MODE = 'archiveMode'
export const BY_COUNTRY = 'byCountry'
